<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户流水</span>
        </div>

        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="日期" prop="title">
            <el-date-picker
              v-model="queryParams.time"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="变化类型" prop="action">
            <el-select
              v-model.number="queryParams.changeType"
              filterable
              placeholder="请选择发奖原因"
              clearable
              size="small"
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in changeType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="用户ID" prop="title">
            <el-input v-model.number="queryParams.uid" placeholder="请输入用户ID" @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="发奖原因" prop="action">
            <el-select
              v-model="queryParams.rid"
              filterable
              placeholder="请选择发奖原因"
              size="small"
              clearable
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in ridType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="奖励类型" prop="type">
            <el-select
              v-model.number="queryParams.type"
              filterable
              placeholder="请选择类型"
              size="small"
              clearable
              @keyup.enter.native="handleQuery"
            >
              <el-option
                v-for="(item, index) in rewardType"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
          </el-form-item>
        </el-form>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-class-name="handleHeaderClass"
          @header-click="handleHeaderCLick"
          @sort-change="handleTableSort"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            width="200"
          />
          <el-table-column
            prop="rid"
            label="发奖原因"
            width="200"
          >
            <template scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.rid" placement="right">
                <span>{{ ridFormatter(scope.row) }}</span>
              </el-tooltip>
            </template>

          </el-table-column>
          <el-table-column
            prop="type"
            label="奖励类型"
            width="200"
            :formatter="typeFormatter"
          />
          <el-table-column
            prop="crease"
            label="变化"
            width="200"
            sortable="custom"
          >
            <template slot-scope="scope">
              {{ scope.row.crease }}{{ scientificFormat('','',scope.row.num) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="reason"
            label="原因"
          />
          <el-table-column
            prop="time"
            label="发放时间"
          />
          <el-table-column
            prop="last_num"
            label="变化后"
            :formatter="scientificFormat"
          />
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRewardType } from '@/api/config/slot'
import { getRewardRecordList, getRidTypeList } from '@/api/config/reward-record'
import { getCacheQuery, setCacheQuery } from '@/utils'

export default {
  name: 'RewardRecord',
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: 100,
        uid: '',
        time: '',
        rid: '',
        type: '',
        changeType: 0,
        order: ''
      },
      ordersList: [],
      loading: false,
      total: 0,
      options: [],
      ridType: [],
      changeType: [{ label: '全部', value: 0 }, { label: '增加', value: 1 }, { label: '减少', value: 2 }],
      tableData: [],
      rewardType: []
    }
  },
  created() {
    this.getRidTypeData()
    this.getRewardTypeData()
    const getUid = this.$route.query.uid
    const getDate = this.$route.query.date
    if (getDate) {
      this.queryParams.time = getDate
    }
    if (getUid > 0) {
      this.queryParams.uid = getUid
    } else {
      const query = this.$store.state.queryForm.rewardForm
      if (query) {
        this.queryParams = query
      }
    }

    if (!this.queryParams.time) {
      this.queryParams.time = this.getCurrentDate()
    }

    if (this.queryParams.uid && this.queryParams.time) {
      this.handleQuery(undefined)
    }
  },
  methods: {
    getRidTypeData() {
      getRidTypeList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.ridType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    handleKeyUp() {
      this.getTables({})
    },
    resetQuery() {
      this.$refs.queryForm.resetFields()
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.time === '') {
        this.msgError('请选择日期')
        return
      }

      if (!this.queryParams.uid) {
        this.msgError('请输入用户ID')
        return
      }

      this.$store.dispatch('queryForm/rewardForm', { value: this.queryParams })
      if (!this.queryParams.pageIndex) {
        this.queryParams.pageIndex = 1
      }
      if (!this.queryParams.pageSize) {
        this.queryParams.pageSize = 100
      }
      if (!this.queryParams.changeType) {
        this.queryParams.changeType = 0
      }

      if (this.queryParams.changeType === 0) {
        this.queryParams.order = ''
      }
      this.getTables({})
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const id = parseInt(i)
            this.rewardType.push({ 'label': res.data[i], 'value': id })
          }
        }
      })
    },
    getTables(event) {
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getRewardRecordList(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        if (res.code === 200) {
          // this.msgSuccess(res.msg)
          this.tableData = res.data.list.data
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    ridFormatter(row, column) {
      let ridName = ''
      for (const i in this.ridType) {
        const val = this.ridType[i]
        if (val.value === row.rid) {
          ridName = val.label
          break
        }
      }
      return ridName
    },
    typeFormatter(row, column) {
      let typeName = ''
      for (const i in this.rewardType) {
        const val = this.rewardType[i]
        if (val.value === row.type) {
          typeName = val.label
          break
        }
      }
      return typeName
    },
    getCurrentDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1 // 月份是从0开始的，所以要加1
      const day = today.getDate()
      // 格式化日期为 'YYYY-MM-DD'
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
    },
    scientificFormat(row, col, value) {
      if (value === 0) {
        return 0
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    handleHeaderClass({ column }) {
      column.order = column.multiOrder
    },
    handleHeaderCLick(column) {
      if (column.sortable !== 'custom') {
        return
      }
      if (!column.multiOrder) {
        column.multiOrder = 'descending'
      } else if (column.multiOrder === 'descending') {
        column.multiOrder = 'ascending'
      } else {
        column.multiOrder = ''
      }
      this.handleOrderChange(column.property, column.multiOrder)
    },
    handleOrderChange(orderColumn, orderState) {
      if (this.queryParams.changeType <= 0) {
        this.msgError('请选择变化类型')
        return
      }
      const result = this.ordersList.find(e => e.orderColumn === orderColumn)
      if (result) {
        result.orderState = orderState
      } else {
        this.ordersList.push({
          orderColumn: orderColumn,
          orderState: orderState
        })
      }
      for (const i in this.ordersList) {
        const val = this.ordersList[i]
        switch (val.orderColumn) {
          case 'crease':
            this.ordersList[i].orderColumn = 'num'
            break
        }
      }
      this.ordersList = [this.ordersList[this.ordersList.length - 1]]
      // this.getDataList()
      if (this.ordersList.length > 0) {
        this.queryParams.order = JSON.stringify(this.ordersList)
        this.handleQuery()
      }
    },
    handleTableSort({ column, prop, order }) {
      // 有些列不需要排序，提前返回
      if (column.sortable !== 'custom') {
        return
      }
      if (!column.multiOrder) {
        column.multiOrder = 'descending'
      } else if (column.multiOrder === 'descending') {
        column.multiOrder = 'ascending'
      } else {
        column.multiOrder = ''
      }

      this.handleOrderChange(column.property, column.multiOrder)
    }
  }
}
</script>

<style scoped>
</style>
